import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'

const defaultKeywords = 'Ethiocert, Cybersecurity, Ethiopia, CERT, Digital Trust, Incident Response'
const defaultAuthor = 'Ethiocert Team'

const MetaTags = ({ title, description, url, image, keywords, author, type = 'website', publishedTime, modifiedTime }) => {
  const siteTitle = title || 'Ethiocert – Official Cybersecurity Platform'
  const siteDescription = description || "Ethiocert – Ethiopia's official cybersecurity and digital trust platform."
  const siteUrl = url || 'https://www.ethiocert.gov.et'
  const siteImage = image || 'https://www.ethiocert.gov.et/og-image.jpg'
  const siteKeywords = keywords || defaultKeywords
  const siteAuthor = author || defaultAuthor

  // Basic JSON-LD (can be extended per page)
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': type === 'article' ? 'Article' : 'WebSite',
    name: siteTitle,
    description: siteDescription,
    url: siteUrl,
    ...(type === 'article' ? { datePublished: publishedTime, dateModified: modifiedTime } : {}),
    publisher: {
      '@type': 'Organization',
      name: 'Ethiocert',
      url: 'https://www.ethiocert.gov.et',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.ethiocert.gov.et/android-chrome-192x192.png'
      }
    }
  }

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <meta name="keywords" content={siteKeywords} />
      <meta name="author" content={siteAuthor} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={siteImage} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:type" content={type} />
  <meta property="og:site_name" content="Ethiocert" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={siteImage} />
      <link rel="canonical" href={siteUrl} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  )
}

MetaTags.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  keywords: PropTypes.string,
  author: PropTypes.string,
  type: PropTypes.string,
  publishedTime: PropTypes.string,
  modifiedTime: PropTypes.string,
}

export default MetaTags
